import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { buildDailyChartData } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-speed-trend',
  templateUrl: './speed-trend.component.html',
  styleUrls: ['./speed-trend.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintSpeedTrendComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  chartContext: ChartContext = {
    type: 'line',
    title: 'روند سرعت روزانه',
    showTitle: false,
    data: [],
    colors: ['#39d9b2'],
    unit: 'km/h',
    theme: 'dark',
    min: 0,
  };

  ngOnChanges(): void {
    const data = buildDailyChartData(this.context.dailySpeed || [], this.context.dates || [], row => {
      const value = row.fSpeedMean;
      return row.iValidSpeedRecords > 0 && typeof value === 'number'
        && Number.isFinite(value) && value >= 0 ? value : null;
    });
    this.chartContext = { ...this.chartContext, data };
  }
}
